





























































































































































































import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import PersonNameBD from "../FormParts/PersonForm/PersonNameBD.vue";
import PersonDriverLicense from "../FormParts/PersonForm/PersonDriverLicense.vue";
import { RecentCardsHelper } from "@/core/helpers/RecentCardsHelper";
import { Driver, InsuranceCard, Person } from "@/services/index.defs";
import PersonDocument from "../FormParts/PersonForm/PersonDocument.vue";
import CarSerial from "../FormParts/CarForm/CarSerial.vue";
import { GaHelper } from "@/core/helpers/ga";
import { EventName, sendPostMessageEvent } from '@/utils/analyticMessages';

@Component({
    components: {
        PersonNameBD,
        PersonDriverLicense,
        PersonDocument,
        CarSerial
    }
})
export default class PrecheckDrivers extends Vue {
    @Ref('driver-license') driverLicenseRef: PersonDriverLicense[];

    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }
    userAgreement = true;
    driversUnlimited = false;
    created() {
        if (this.card.drivers.length === 0) this.driversUnlimited = true;
    }

    get isFastCalcDisabled() {
        return this.$store.direct.getters.isFastCalcDisabled;
    }

    @Watch("driversUnlimited")
    onDriversUnlimitedChanged(val) {
        if (val)
            this.card.drivers = [];
        else
            this.card.drivers.push(new Driver());
    }
    addDriver() {
        this.card.drivers.push(new Driver());
    }
    removeDriver(driver: Driver) {
        this.card.drivers.splice(
            this.card.drivers.findIndex(x => x == driver),
            1
        );
        if (this.card.drivers.length == 0) this.driversUnlimited = true;
    }
    async clearDriver(driver: Driver) {
        const drivers = this.card.drivers;
        if (!Array.isArray(drivers)) {
            console.error('drivers is not array');
            return;
        }
        const driverIdx = drivers.findIndex(x => x == driver);
        if (driverIdx === -1) {
            console.error('driver is not found');
            return;
        }

        drivers.splice(
            driverIdx,
            1,
            new Driver(),
        );

        // Костыль из-за особенности date input
        // при использовании даты формата 43.34.5345 - значение в инпуте становится null
        // при очистке визуально кривое значение остается, сброс будет через установку новой даты и возвращению к null
        if (this.driverLicenseRef?.length) {
            await this.$nextTick();
            const selectedDriverLicenseRef = this.driverLicenseRef[driverIdx];
            if (selectedDriverLicenseRef)
                selectedDriverLicenseRef.clearYearField();
        }
        await this.$nextTick();
        drivers[driverIdx].firstLicenseDate = new Date();
        drivers[driverIdx].person.birthDate = new Date();
        await this.$nextTick();
        drivers[driverIdx].firstLicenseDate = null;
        drivers[driverIdx].person.birthDate = null;
    }
    clearOwner() {
        this.card.owner = new Person();
    }
    clearCarSerial() {
        let car = this.card.car;
        car.chassisNumber = "";
        car.bodyNumber = "";
        car.vin = "";
    }

    errorMessage: string = "";
    @Ref("form") form: { validate: Function };
    calculate() {
        let isValid = this.form.validate();
        if (!isValid) return;
        this.errorMessage = "";
        if (this.card.haveDoubleDrivers) {
            this.errorMessage =
                "У нескольких водителей совпадает серия и номер водительского удостоверения";
            return;
        }

        this.$store.direct.dispatch.info.loadDriversKbm(this.card.drivers);
        const isCardSavedEarlier = !!RecentCardsHelper.getCard(
            RecentCardsHelper.createCardName(this.$store, this.card)
        );
        if (
            this.card.car.markId &&
            this.card.car.modelId &&
            !isCardSavedEarlier
        )
            this.rememberCard();

        sendPostMessageEvent(EventName.DriverInfo);
        this.$emit("next");
    }
    rememberCard() {
        RecentCardsHelper.rememberCard(
            this.card,
            RecentCardsHelper.createCardName(this.$store, this.card)
        );
    }
    mounted() {
        GaHelper.send("drivers");
    }
    openLink() {
        const link =
            "https://docs.google.com/document/d/11-wWOCxWoCVpqARBTOJ3uIE6VpyfOdTOSZU23ASUpwg/edit";
        window.open(link, "_blank");
    }
}
